import {useCallback} from 'react';
import {useHistory, useLocation} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import '../../assets/styles/payment/publicPages.scss';
import usePageMeta from '../../services/page-meta';
import {resolveLocalePrefix, usePaymentPayload} from './helpers';

const SUPPORT_CAPTIONS = [
    'Оплата картами Visa и Mastercard обеспечивается сервисом онлайн-платежей Portmone.com. Безопасность оплаты подтверждена международным аудитом PCI DSS. Служба поддержки: тел. ',
    'Розрахунок картками Visa та Mastercard забезпечується сервісом онлайн-платежів Portmone.com. Безпека оплати підтверджена міжнародним аудитом PCI DSS. Служба підтримки: тел. ',
    'Payment by Visa and Mastercard is provided by service of online-payments Portmone.com. Payment safety was confirmed by PCI DSS security audit. In case of questions call or email us: ',
];

export default function PaymentDescriptionPage() {
    const {t} = useTranslation();
    usePageMeta({
        title: t('meta.paymentDescription.title', t('payment.paymentDescription.title')),
        description: t('meta.paymentDescription.description', t('app.description')),
        keywords: t('meta.paymentDescription.keywords', t('app.keywords')),
    });

    const history = useHistory();
    const location = useLocation();
    const {payload, isLoading} = usePaymentPayload('/api/v1/payment');

    const handleGoBack = useCallback((event) => {
        event.preventDefault();

        if (window.history.length > 1) {
            history.goBack();
            return;
        }

        const localePrefix = resolveLocalePrefix(location.pathname);
        history.push(`${localePrefix}/`);
    }, [history, location.pathname]);

    if (isLoading || payload?.state !== 'active') {
        return <section className="payment-support-page payment-support-section" />;
    }

    const paymentLogosImageUrl = payload?.assets?.paymentLogosImageUrl || '/img/payment/payment-logos.png';
    const securityLogosImageUrl = payload?.assets?.securityLogosImageUrl || '/img/payment/security-logos.png';

    return (
        <div className="payment-support-page">
            <section className="payment-support-section">
                <div className="container">
                    <div className="payment-header flex-center">
                        <div className="link-block">
                            <button type="button" className="payment-back-btn js-go-back" onClick={handleGoBack}>
                                {t('app.back')}
                            </button>
                        </div>
                        <h1>{t('payment.paymentDescription.title')}</h1>
                    </div>
                    <div className="wrap">
                        <h5>{t('payment.paymentDescription.payments')}</h5>
                        <p dangerouslySetInnerHTML={{__html: t('payment.paymentDescription.portmone')}} />
                        <img src={paymentLogosImageUrl} alt="" className="img" />

                        {SUPPORT_CAPTIONS.map((caption) => (
                            <p className="sub-text" key={caption}>
                                {caption}
                                <a href="tel:+380442000902">+380(44)2000902</a>, <a href="mailto:support@portmone.com">support@portmone.com</a>
                            </p>
                        ))}

                        <h5>{t('payment.paymentDescription.protection')}</h5>
                        <p dangerouslySetInnerHTML={{__html: t('payment.dataProtection.privacyPolicy')}} />
                        <h5>{t('payment.dataProtection.title')}</h5>
                        <img src={securityLogosImageUrl} alt="" className="img" />
                        <p>{t('payment.dataProtection.cardSecurityCaption')}</p>

                        <h5>{t('payment.cashBack.header')}</h5>
                        <p dangerouslySetInnerHTML={{__html: t('payment.cashBack.contactUs')}} />
                        <h5>{t('payment.cashBack.refundPolicy')}</h5>
                        <div dangerouslySetInnerHTML={{__html: t('payment.cashBack.refundPolicyList')}} />
                        <h5>{t('payment.cashBack.refundMethods')}</h5>
                        <p>{t('payment.cashBack.refundMethodsCaption')}</p>
                        <p>{t('payment.cashBack.notPublic')}</p>
                    </div>
                </div>
            </section>
        </div>
    );
}
